import { useEffect } from 'react'

const CODE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a']

/** ↑ ↑ ↓ ↓ ← → ← → B A */
export function useKonami(onUnlock: () => void): void {
	useEffect(() => {
		let i = 0
		const onKey = (e: KeyboardEvent) => {
			i = e.key === CODE[i] ? i + 1 : e.key === CODE[0] ? 1 : 0
			if (i === CODE.length) {
				i = 0
				onUnlock()
			}
		}
		addEventListener('keydown', onKey)
		return () => removeEventListener('keydown', onKey)
	}, [onUnlock])
}
